import React from 'react';
import DefaultLayout from '@presentation/layouts/DefaultLayout';
import BenefitTopic from '@presentation/pages/Benefits/BenefitTopic';
import type { BenefitTopic as BenefitTopicModel } from '@presentation/content/types';

const makeBenefitTopic = (topic: BenefitTopicModel) => (
	<DefaultLayout>
		<BenefitTopic topic={topic} />
	</DefaultLayout>
);

export default makeBenefitTopic;
